export const TABLE_ICON_COLUMN_WIDTH = 40;
